import React from 'react';
import { bn } from '../../utils/bn';
export interface MapMarker {
  id: string;
  x: number;
  y: number;
  label: string;
  kind: 'custody' | 'station' | 'pin';
  count?: number;
}
interface DhakaMapProps {
  markers: MapMarker[];
  selectedId?: string;
  onSelect?: (id: string) => void;
  onPick?: (x: number, y: number) => void;
  className?: string;
  highlightArea?: string;
}
const AREAS = [{
  label: 'উত্তরা',
  x: 222,
  y: 30
}, {
  label: 'বিমানবন্দর',
  x: 262,
  y: 92
}, {
  label: 'মিরপুর',
  x: 118,
  y: 172
}, {
  label: 'গুলশান',
  x: 298,
  y: 168
}, {
  label: 'মহাখালী',
  x: 262,
  y: 212
}, {
  label: 'তেজগাঁও',
  x: 252,
  y: 244
}, {
  label: 'ফার্মগেট',
  x: 160,
  y: 262
}, {
  label: 'ধানমন্ডি',
  x: 142,
  y: 308
}, {
  label: 'রমনা',
  x: 214,
  y: 302
}, {
  label: 'মতিঝিল',
  x: 272,
  y: 328
}, {
  label: 'লালবাগ',
  x: 118,
  y: 378
}, {
  label: 'যাত্রাবাড়ী',
  x: 318,
  y: 404
}];
export function DhakaMap({
  markers,
  selectedId,
  onSelect,
  onPick,
  className = 'h-72',
  highlightArea
}: DhakaMapProps) {
  const handleClick = (e: React.MouseEvent<SVGSVGElement>) => {
    if (!onPick) return;
    const svg = e.currentTarget;
    const pt = svg.createSVGPoint();
    pt.x = e.clientX;
    pt.y = e.clientY;
    const ctm = svg.getScreenCTM();
    if (!ctm) return;
    const p = pt.matrixTransform(ctm.inverse());
    onPick(Math.round(p.x), Math.round(p.y));
  };
  return <div className={`relative overflow-hidden rounded-xl border border-line bg-[#EEF4F8] ${className}`} data-id="element-319" data-mp="1i59hoej63st8">
      <svg viewBox="0 0 400 460" className={`h-full w-full ${onPick ? 'cursor-crosshair' : ''}`} onClick={handleClick} role="img" aria-label="ঢাকা মহানগরের নমুনা মানচিত্র" data-id="element-320" data-mp="18d3sfckavphq">
        <rect width="400" height="460" fill="#EEF4F8" data-id="element-321" data-mp="14bqk8vtqja7n" />
        <path d="M70,10 L360,10 L372,150 L360,300 L345,420 L90,425 L75,300 L85,160 Z" fill="#F8FBFD" stroke="#D6E2EC" strokeWidth="1.5" data-id="element-322" data-mp="zd6yowj200ft" />
        <path d="M40,0 C60,80 30,160 55,240 C70,300 40,360 60,420 L44,420 C24,360 52,300 38,240 C14,160 44,80 24,0 Z" fill="#BFD9EC" data-id="element-323" data-mp="ucj98fah3rnp" />
        <path d="M0,428 C80,408 140,438 200,446 C260,454 320,436 400,450 L400,460 L0,460 Z" fill="#BFD9EC" data-id="element-324" data-mp="fqlwqzvr63vz" />
        <path d="M386,0 C366,100 394,200 376,300 C366,360 390,400 386,444 L400,444 L400,0 Z" fill="#BFD9EC" data-id="element-325" data-mp="kpfdd16c6b0d" />
        <path d="M282,150 C292,160 288,186 300,200 C306,210 296,214 290,206 C280,192 276,170 282,150 Z" fill="#CFE3F1" data-id="element-326" data-mp="6qfp3umqjy4q" />
        <path d="M150,280 C158,290 154,310 162,320 C158,324 150,316 148,304 C146,294 146,286 150,280 Z" fill="#CFE3F1" data-id="element-327" data-mp="asalqltq1nc6" />
        <g fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-328" data-mp="yhvhk5az4f2v">
          {['M232,14 L246,110 L240,200 L222,250 L204,318 L252,340 L296,402', 'M120,140 L150,200 L178,252 L194,318 L210,400', 'M110,150 L190,176 L244,198 L310,182 L360,190', 'M140,370 L200,352 L252,340 L330,350', 'M90,258 L178,252 L222,250 L300,256 L360,262', 'M246,110 L300,120 L340,110'].map(d => <g key={d} data-id="element-329" data-mp="1m6xwh5e83tto">
              <path d={d} stroke="#D3DEE8" strokeWidth="7" data-id="element-330" data-mp="1m7hd8is50c64" />
              <path d={d} stroke="#FFFFFF" strokeWidth="4.5" data-id="element-331" data-mp="36wl783lgsm7p" />
            </g>)}
        </g>
        {AREAS.map(a => <text key={a.label} x={a.x} y={a.y} textAnchor="middle" className="select-none" fontSize="11" fontWeight={highlightArea === a.label ? 700 : 500} fill={highlightArea === a.label ? '#0B4778' : '#7E91A3'} data-id="element-332" data-mp="31x8krjyi9h5n">
            {a.label}
          </text>)}
        {markers.map(m => {
        const selected = m.id === selectedId;
        if (m.kind === 'station') {
          return <g key={m.id} transform={`translate(${m.x},${m.y})`} className={onSelect ? 'cursor-pointer' : ''} onClick={e => {
            e.stopPropagation();
            onSelect?.(m.id);
          }} data-id="element-333" data-mp="2j0fp5h1v8485">
                <title data-id="element-334" data-mp="2sx2as820mzb8">{m.label}</title>
                <rect x={-15} y={-12} width={30} height={22} rx={5} fill={selected ? '#006B42' : '#008451'} stroke="#fff" strokeWidth={2} data-id="element-335" data-mp="2sw0p79ndiuf9" />
                <text y={4} textAnchor="middle" fontSize="10" fontWeight={700} fill="#fff" data-id="element-336" data-mp="87cwbw585fj2">{m.count !== undefined ? bn(m.count) : 'D'}</text>
                {selected && <rect x={-19} y={-16} width={38} height={30} rx={7} fill="none" stroke="#008451" strokeWidth={2} data-id="element-337" data-mp="2dx7wty3juifj" />}
              </g>;
        }
        const color = m.kind === 'pin' ? '#D64545' : '#0B4778';
        return <g key={m.id} transform={`translate(${m.x},${m.y})`} className={onSelect ? 'cursor-pointer' : ''} onClick={e => {
          e.stopPropagation();
          onSelect?.(m.id);
        }} data-id="element-338" data-mp="2ruwjnbh6fzn8">
              <title data-id="element-339" data-mp="2ws51tc2bs3oh">{m.label}</title>
              {selected && <circle r={14} fill={color} opacity={0.18} data-id="element-340" data-mp="31sj38b9f8fdj" />}
              <path d="M0,0 C-7,-9 -9,-13 -9,-17 A9,9 0 1 1 9,-17 C9,-13 7,-9 0,0 Z" fill={color} stroke="#fff" strokeWidth={1.8} data-id="element-341" data-mp="36k112qg5dzua" />
              <circle cy={-17} r={3.2} fill="#fff" data-id="element-342" data-mp="3alw0fpeiq35f" />
            </g>;
      })}
      </svg>
      <span className="absolute bottom-2 left-2 rounded bg-white/90 px-2 py-0.5 text-[10px] font-semibold text-ink-muted" data-id="element-343" data-mp="3flifm4dwptgv">নমুনা মানচিত্র — প্রকৃত GIS নয়</span>
    </div>;
}